import React, { Component, Fragment } from 'react';
import TitleContainer from './components/titleContainer';

const isMobile = /Android|webOS|iPhone|iPod|pad|ipad/i.test(navigator.userAgent);
export default class Technology extends Component {
  render() {
    const rows = [
      { img: require('./image/technology1.jpg'), title: '01', smallT: '深入行业场景', left: true, content: '红创拥有具备强大实力的技术研发人才团队，并深入了解服装定制、智慧零售、医疗大数据等多个行业场景。' },
      { img: require('./image/technology2.jpg'), title: '02', smallT: '领先的核心算法', left: false, content: '由红创自主原创的深度学习框架，能够为红创科技的智能算法训练和模型改进过程提供关键支持。多项核心技术拥有完整的知识产权。'},
      { img: require('./image/technology3.jpg'), title: '03', smallT: '全栈技术服务', left: true, content: '基于红创高质量的软硬件研发、整合能力，红创可以为智慧定制、智慧医疗等场景提供全栈的人工智能解决方案。'},
    ];

    return isMobile ? this.renderMobile(rows) : this.renderWeb(rows);
  }
  renderMobile = (rows) => (
    <Fragment>
      <div className='cooperation-t'>技术介绍</div>
      <div className="tech-content-area">
        {rows.map(({ img, left, title, smallT, content }, index) => [
          index !== 0 && <div className="tech-row-line"/>,
          <div className="tech-row-contain">
            <img src={img} className="mobile-row-show-contain-img"/>
            <div className="tech-t-contain" style={{ alignItems: 'flex-start' }}>
              <div className="tech-t-m">{title}</div>
              <div className="tech-line-m" />
              <div className="tech-st-m">{smallT}</div>
              <div className="tech-c-m">{content}</div>
            </div>
          </div>,
        ])}
      </div>
    </Fragment>
  )
  
  renderWeb = (rows) => (
    <Fragment>
      <TitleContainer slogan={require('./image/slogn-technology.svg')} tie={require('./image/technology-tie.svg')} />
      <div className="content-area">
        {rows.map(({ img, left, title, smallT, content }) => (
          <div className="row-show-contain" style={{ flexDirection: left ? 'row' : 'row-reverse' }}>
            <img src={img} className="row-show-contain-img" style={left ? { marginRight: '40px' } : { marginLeft: '40px' }} />
            <div className="technology-item-contain" style={{ alignItems: !left ? 'flex-start' : 'flex-end' }}>
              <div className="technology-item-title">{title}</div>
              <div className="technology-line" />
              <p className="technology-item-subtitle">{smallT}</p>
              <p className="technology-item-desc">{content}</p>
            </div>
          </div>
        ))}
      </div>
    </Fragment>
  )
}




// WEBPACK FOOTER //
// ./src/Technology.js